/** Official Bharat Training social profiles */

export const SOCIAL_LINKS = [
  {
    label: 'YouTube',
    url: 'https://youtube.com/@bharattraining-l8w?si=C3sHckE1SqbmPbys',
    brand: '#FF0000',
  },
  {
    label: 'WhatsApp',
    url: 'https://wa.me/918851868521',
    brand: '#25D366',
  },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/hr.bharattraining0505?igsh=MXRueXN6aHR1ZWVzZg==',
    brand: '#E4405F',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/lata-joshi-332882203?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    brand: '#0A66C2',
  },
  {
    label: 'Facebook',
    url: 'https://www.facebook.com/people/BI-T/pfbid0b52YJTMPAURvBtsL5FJT6SMJQmXSP89Cdr6pBdJwck9DS3LZPen7ZFwm2v2L5kRrl/',
    brand: '#1877F2',
  },
];

/** PLC / automation training videos (YouTube) + link to your channel */
export const FEATURED_VIDEOS = [
  {
    id: 'R3ub7Eu37pE',
    title: 'PLC Programming — Ladder Logic Basics',
    featured: true,
  },
  {
    id: 'kQ2jXoKhDdM',
    title: 'SCADA Systems — How They Work',
  },
  {
    id: 'MFzDaBzBlL0',
    title: 'Industrial Automation Overview',
  },
];

export const YOUTUBE_CHANNEL = 'https://youtube.com/@bharattraining-l8w';

/** Royalty-free industrial background videos (Mixkit) */
export const HERO_VIDEO =
  'https://assets.mixkit.co/videos/preview/mixkit-industrial-factory-with-machines-in-operation-2990-large.mp4';
export const SECTION_VIDEO =
  'https://assets.mixkit.co/videos/preview/mixkit-robot-working-in-an-industrial-production-line-42797-large.mp4';
